// This file is generated by mastracode/factory/scripts/generate-api-cli-route-metadata.ts. Do not edit by hand.

export const FACTORY_API_ROUTE_METADATA = {
  "DELETE /web/factory/projects/:id": {
    "contractKey": "projectDelete",
    "method": "DELETE",
    "path": "/web/factory/projects/:id",
    "description": "Delete a Factory project",
    "pathParams": [
      "id"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "DELETE /web/factory/work-items/:id": {
    "contractKey": "workItemDelete",
    "method": "DELETE",
    "path": "/web/factory/work-items/:id",
    "description": "Delete a Factory work item",
    "pathParams": [
      "id"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /web/factory/projects": {
    "contractKey": "projectList",
    "method": "GET",
    "path": "/web/factory/projects",
    "description": "List Factory projects for the current organization",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "projects"
    }
  },
  "GET /web/factory/projects/:id": {
    "contractKey": "projectGet",
    "method": "GET",
    "path": "/web/factory/projects/:id",
    "description": "Get a Factory project",
    "pathParams": [
      "id"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /web/factory/projects/:id/attention": {
    "contractKey": "attentionList",
    "method": "GET",
    "path": "/web/factory/projects/:id/attention",
    "description": "List the Factory attention inbox",
    "pathParams": [
      "id"
    ],
    "queryParams": [
      "before",
      "kind",
      "limit",
      "search",
      "view"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /web/factory/projects/:id/boards": {
    "contractKey": "boardCatalog",
    "method": "GET",
    "path": "/web/factory/projects/:id/boards",
    "description": "List installed Factory boards",
    "pathParams": [
      "id"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "boards"
    }
  },
  "GET /web/factory/projects/:id/decisions": {
    "contractKey": "decisionList",
    "method": "GET",
    "path": "/web/factory/projects/:id/decisions",
    "description": "List Factory decisions",
    "pathParams": [
      "id"
    ],
    "queryParams": [
      "before",
      "limit",
      "statuses"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "decisions"
    }
  },
  "GET /web/factory/projects/:id/health/thresholds": {
    "contractKey": "healthThresholdsGet",
    "method": "GET",
    "path": "/web/factory/projects/:id/health/thresholds",
    "description": "Get queue-health thresholds",
    "pathParams": [
      "id"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "object-property",
      "listProperty": "thresholds"
    }
  },
  "GET /web/factory/projects/:id/metrics": {
    "contractKey": "metricsGet",
    "method": "GET",
    "path": "/web/factory/projects/:id/metrics",
    "description": "Get Factory project metrics",
    "pathParams": [
      "id"
    ],
    "queryParams": [
      "from",
      "to"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /web/factory/projects/:id/supervisor/health": {
    "contractKey": "supervisorHealth",
    "method": "GET",
    "path": "/web/factory/projects/:id/supervisor/health",
    "description": "Run the deterministic Factory supervisor health check",
    "pathParams": [
      "id"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "GET /web/factory/projects/:id/work-items": {
    "contractKey": "workItemList",
    "method": "GET",
    "path": "/web/factory/projects/:id/work-items",
    "description": "List Factory work items and running sessions",
    "pathParams": [
      "id"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "PATCH /web/factory/projects/:id": {
    "contractKey": "projectUpdate",
    "method": "PATCH",
    "path": "/web/factory/projects/:id",
    "description": "Update a Factory project",
    "pathParams": [
      "id"
    ],
    "queryParams": [],
    "bodyParams": [
      "autoApprovePlans",
      "autoRunEnabled",
      "defaultModelId",
      "description",
      "name",
      "slackWorkItemsEnabled"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "PATCH /web/factory/work-items/:id": {
    "contractKey": "workItemUpdate",
    "method": "PATCH",
    "path": "/web/factory/work-items/:id",
    "description": "Update non-stage work-item fields",
    "pathParams": [
      "id"
    ],
    "queryParams": [],
    "bodyParams": [
      "board",
      "metadata",
      "parentWorkItemId",
      "plansPreapproved",
      "sessions",
      "stages",
      "title"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /web/factory/projects": {
    "contractKey": "projectCreate",
    "method": "POST",
    "path": "/web/factory/projects",
    "description": "Create a Factory project",
    "pathParams": [],
    "queryParams": [],
    "bodyParams": [
      "description",
      "name"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /web/factory/projects/:id/apply-default-model": {
    "contractKey": "projectApplyDefaultModel",
    "method": "POST",
    "path": "/web/factory/projects/:id/apply-default-model",
    "description": "Apply the Factory default model to running work and review threads",
    "pathParams": [
      "id"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /web/factory/projects/:id/attention/:kind/:sourceId/:occurrence/archive": {
    "contractKey": "attentionArchive",
    "method": "POST",
    "path": "/web/factory/projects/:id/attention/:kind/:sourceId/:occurrence/archive",
    "description": "Archive a Factory attention receipt",
    "pathParams": [
      "id",
      "kind",
      "sourceId",
      "occurrence"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /web/factory/projects/:id/attention/:kind/:sourceId/:occurrence/read": {
    "contractKey": "attentionRead",
    "method": "POST",
    "path": "/web/factory/projects/:id/attention/:kind/:sourceId/:occurrence/read",
    "description": "Mark a Factory attention receipt as read",
    "pathParams": [
      "id",
      "kind",
      "sourceId",
      "occurrence"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /web/factory/projects/:id/attention/:kind/:sourceId/:occurrence/restore": {
    "contractKey": "attentionRestore",
    "method": "POST",
    "path": "/web/factory/projects/:id/attention/:kind/:sourceId/:occurrence/restore",
    "description": "Restore an archived Factory attention receipt",
    "pathParams": [
      "id",
      "kind",
      "sourceId",
      "occurrence"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /web/factory/projects/:id/attention/read-all": {
    "contractKey": "attentionReadAll",
    "method": "POST",
    "path": "/web/factory/projects/:id/attention/read-all",
    "description": "Mark all Factory attention as read",
    "pathParams": [
      "id"
    ],
    "queryParams": [
      "before"
    ],
    "bodyParams": [],
    "hasQuery": true,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /web/factory/projects/:id/decisions/:decisionId/approve": {
    "contractKey": "decisionApprove",
    "method": "POST",
    "path": "/web/factory/projects/:id/decisions/:decisionId/approve",
    "description": "Approve a proposed Factory decision",
    "pathParams": [
      "id",
      "decisionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /web/factory/projects/:id/decisions/:decisionId/dismiss": {
    "contractKey": "decisionDismiss",
    "method": "POST",
    "path": "/web/factory/projects/:id/decisions/:decisionId/dismiss",
    "description": "Dismiss a proposed Factory decision",
    "pathParams": [
      "id",
      "decisionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /web/factory/projects/:id/decisions/:decisionId/retry": {
    "contractKey": "decisionRetry",
    "method": "POST",
    "path": "/web/factory/projects/:id/decisions/:decisionId/retry",
    "description": "Retry a failed retryable Factory decision",
    "pathParams": [
      "id",
      "decisionId"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /web/factory/projects/:id/runs/start": {
    "contractKey": "workItemStart",
    "method": "POST",
    "path": "/web/factory/projects/:id/runs/start",
    "description": "Explicitly start a Factory work-item run",
    "pathParams": [
      "id"
    ],
    "queryParams": [],
    "bodyParams": [
      "kickoffKey",
      "sessionId",
      "threadTitle",
      "workItem"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "record"
    }
  },
  "POST /web/factory/projects/:id/supervisor/session": {
    "contractKey": "supervisorSession",
    "method": "POST",
    "path": "/web/factory/projects/:id/supervisor/session",
    "description": "Get the deterministic Factory supervisor session address",
    "pathParams": [
      "id"
    ],
    "queryParams": [],
    "bodyParams": [],
    "hasQuery": false,
    "hasBody": false,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /web/factory/projects/:id/work-items": {
    "contractKey": "workItemCreate",
    "method": "POST",
    "path": "/web/factory/projects/:id/work-items",
    "description": "Create a work item in Intake",
    "pathParams": [
      "id"
    ],
    "queryParams": [],
    "bodyParams": [
      "board",
      "externalSource",
      "metadata",
      "parentWorkItemId",
      "sessions",
      "stages",
      "title"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "single"
    }
  },
  "POST /web/factory/projects/:id/work-items/:workItemId/automation-runs": {
    "contractKey": "workItemAutomationRun",
    "method": "POST",
    "path": "/web/factory/projects/:id/work-items/:workItemId/automation-runs",
    "description": "Enqueue an idempotent deferred skill dispatch for a trusted external orchestrator",
    "pathParams": [
      "id",
      "workItemId"
    ],
    "queryParams": [],
    "bodyParams": [
      "arguments",
      "expectedRevision",
      "requestId",
      "role",
      "skillName"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "record"
    }
  },
  "POST /web/factory/projects/:id/work-items/:workItemId/transition": {
    "contractKey": "workItemTransition",
    "method": "POST",
    "path": "/web/factory/projects/:id/work-items/:workItemId/transition",
    "description": "Transition a work item with its expected revision",
    "pathParams": [
      "id",
      "workItemId"
    ],
    "queryParams": [],
    "bodyParams": [
      "board",
      "cause",
      "expectedRevision",
      "reenter",
      "requestId",
      "stage"
    ],
    "hasQuery": false,
    "hasBody": true,
    "responseShape": {
      "kind": "record"
    }
  }
} as const;

export const FACTORY_API_ROUTE_SCHEMAS = {
  "DELETE /web/factory/projects/:id": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "null"
    }
  },
  "DELETE /web/factory/work-items/:id": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "ok": {
          "type": "boolean",
          "const": true
        }
      },
      "required": [
        "ok"
      ]
    }
  },
  "GET /web/factory/projects": {
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "projects": {
          "type": "array",
          "items": {
            "type": "object",
            "propertyNames": {
              "type": "string"
            },
            "additionalProperties": {}
          }
        }
      },
      "required": [
        "projects"
      ]
    }
  },
  "GET /web/factory/projects/:id": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "project": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        }
      },
      "required": [
        "project"
      ]
    }
  },
  "GET /web/factory/projects/:id/attention": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "query": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "view": {
          "default": "open",
          "type": "string",
          "enum": [
            "open",
            "unread",
            "archived"
          ]
        },
        "kind": {
          "type": "array",
          "items": {
            "type": "string",
            "enum": [
              "automation-failed",
              "automation-proposed",
              "mention",
              "activity",
              "supervisor-finding",
              "agent-waiting"
            ]
          }
        },
        "before": {
          "type": "string"
        },
        "limit": {
          "type": "string"
        },
        "search": {
          "type": "string"
        }
      }
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "items": {
          "type": "array",
          "items": {
            "type": "object",
            "propertyNames": {
              "type": "string"
            },
            "additionalProperties": {}
          }
        },
        "kinds": {
          "type": "object",
          "propertyNames": {
            "type": "string",
            "enum": [
              "automation-failed",
              "automation-proposed",
              "mention",
              "activity",
              "supervisor-finding",
              "agent-waiting"
            ]
          },
          "additionalProperties": {
            "type": "object",
            "properties": {
              "open": {
                "type": "number"
              },
              "unread": {
                "type": "number"
              },
              "latest": {
                "anyOf": [
                  {
                    "type": "object",
                    "properties": {
                      "key": {
                        "type": "string"
                      },
                      "at": {
                        "type": "string"
                      },
                      "unread": {
                        "type": "boolean"
                      }
                    },
                    "required": [
                      "key",
                      "at",
                      "unread"
                    ]
                  },
                  {
                    "type": "null"
                  }
                ]
              }
            },
            "required": [
              "open",
              "unread",
              "latest"
            ]
          },
          "required": [
            "automation-failed",
            "automation-proposed",
            "mention",
            "activity",
            "supervisor-finding",
            "agent-waiting"
          ]
        },
        "hasMore": {
          "type": "boolean"
        },
        "nextCursor": {
          "type": "string"
        }
      },
      "required": [
        "items",
        "kinds",
        "hasMore"
      ]
    }
  },
  "GET /web/factory/projects/:id/boards": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "boards": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "id": {
                "type": "string"
              },
              "title": {
                "type": "string"
              },
              "initialPhase": {
                "type": "string"
              },
              "phases": {
                "type": "array",
                "items": {
                  "type": "object",
                  "properties": {
                    "id": {
                      "type": "string"
                    },
                    "title": {
                      "type": "string"
                    },
                    "kind": {
                      "type": "string",
                      "enum": [
                        "resting",
                        "working",
                        "terminal"
                      ]
                    },
                    "role": {
                      "type": "string"
                    },
                    "transitions": {
                      "type": "array",
                      "items": {
                        "type": "object",
                        "properties": {
                          "outcome": {
                            "type": [
                              "string",
                              "null"
                            ]
                          },
                          "to": {
                            "type": "string"
                          }
                        },
                        "required": [
                          "outcome",
                          "to"
                        ]
                      }
                    }
                  },
                  "required": [
                    "id",
                    "title",
                    "kind",
                    "transitions"
                  ]
                }
              }
            },
            "required": [
              "id",
              "title",
              "initialPhase",
              "phases"
            ]
          }
        }
      },
      "required": [
        "boards"
      ]
    }
  },
  "GET /web/factory/projects/:id/decisions": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "query": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "statuses": {
          "type": "string"
        },
        "before": {
          "type": "string"
        },
        "limit": {
          "type": "string"
        }
      }
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "decisions": {
          "type": "array",
          "items": {
            "type": "object",
            "propertyNames": {
              "type": "string"
            },
            "additionalProperties": {}
          }
        },
        "nextCursor": {
          "type": "string"
        }
      },
      "required": [
        "decisions"
      ]
    }
  },
  "GET /web/factory/projects/:id/health/thresholds": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "thresholds": {
          "type": "array",
          "items": {
            "type": "number"
          }
        }
      },
      "required": [
        "thresholds"
      ]
    }
  },
  "GET /web/factory/projects/:id/metrics": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "query": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "from": {
          "type": "string"
        },
        "to": {
          "type": "string"
        }
      }
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "metrics": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        }
      },
      "required": [
        "metrics"
      ]
    }
  },
  "GET /web/factory/projects/:id/supervisor/health": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "checkedAt": {
          "type": "string"
        },
        "findings": {
          "type": "array",
          "items": {
            "type": "object",
            "propertyNames": {
              "type": "string"
            },
            "additionalProperties": {}
          }
        },
        "counts": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {
            "type": "integer",
            "minimum": 0,
            "maximum": 9007199254740991
          }
        }
      },
      "required": [
        "checkedAt",
        "findings",
        "counts"
      ]
    }
  },
  "GET /web/factory/projects/:id/work-items": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "workItems": {
          "type": "array",
          "items": {
            "type": "object",
            "propertyNames": {
              "type": "string"
            },
            "additionalProperties": {}
          }
        },
        "runningSessionIds": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "parkedSessionIds": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      "required": [
        "workItems",
        "runningSessionIds",
        "parkedSessionIds"
      ]
    }
  },
  "PATCH /web/factory/projects/:id": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "body": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "name": {
          "$ref": "#/$defs/__schema0"
        },
        "description": {
          "$ref": "#/$defs/__schema1"
        },
        "defaultModelId": {
          "$ref": "#/$defs/__schema2"
        },
        "slackWorkItemsEnabled": {
          "$ref": "#/$defs/__schema3"
        },
        "autoRunEnabled": {
          "$ref": "#/$defs/__schema4"
        },
        "autoApprovePlans": {
          "$ref": "#/$defs/__schema5"
        }
      },
      "$defs": {
        "__schema0": {
          "type": "string",
          "minLength": 1,
          "maxLength": 200
        },
        "__schema1": {
          "anyOf": [
            {
              "type": "string",
              "maxLength": 2000
            },
            {
              "type": "null"
            }
          ]
        },
        "__schema2": {
          "anyOf": [
            {
              "type": "string",
              "maxLength": 200
            },
            {
              "type": "null"
            }
          ]
        },
        "__schema3": {
          "type": "boolean"
        },
        "__schema4": {
          "type": "boolean"
        },
        "__schema5": {
          "type": "boolean"
        }
      }
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "project": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        }
      },
      "required": [
        "project"
      ]
    }
  },
  "PATCH /web/factory/work-items/:id": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "body": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "title": {
          "$ref": "#/$defs/__schema0"
        },
        "board": {
          "$ref": "#/$defs/__schema1"
        },
        "parentWorkItemId": {
          "$ref": "#/$defs/__schema2"
        },
        "stages": {
          "$ref": "#/$defs/__schema3"
        },
        "sessions": {
          "$ref": "#/$defs/__schema5"
        },
        "metadata": {
          "$ref": "#/$defs/__schema6"
        },
        "plansPreapproved": {
          "$ref": "#/$defs/__schema9"
        }
      },
      "$defs": {
        "__schema0": {
          "type": "string",
          "maxLength": 500
        },
        "__schema1": {
          "type": "string",
          "minLength": 1,
          "maxLength": 128
        },
        "__schema2": {
          "anyOf": [
            {
              "type": "string",
              "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
            },
            {
              "type": "null"
            }
          ]
        },
        "__schema3": {
          "minItems": 1,
          "maxItems": 16,
          "type": "array",
          "items": {
            "$ref": "#/$defs/__schema4"
          }
        },
        "__schema4": {
          "type": "string",
          "maxLength": 64,
          "pattern": "^[a-z0-9][a-z0-9_-]*$"
        },
        "__schema5": {
          "type": "object",
          "propertyNames": {
            "type": "string",
            "minLength": 1,
            "maxLength": 64
          },
          "additionalProperties": {
            "type": "object",
            "properties": {
              "sessionId": {
                "type": "string",
                "minLength": 1,
                "maxLength": 512
              },
              "branch": {
                "type": "string",
                "minLength": 1,
                "maxLength": 512
              },
              "threadId": {
                "type": "string",
                "minLength": 1,
                "maxLength": 512
              }
            },
            "required": [
              "sessionId",
              "branch",
              "threadId"
            ]
          }
        },
        "__schema6": {
          "anyOf": [
            {
              "$ref": "#/$defs/__schema7"
            },
            {
              "$ref": "#/$defs/__schema8"
            }
          ]
        },
        "__schema7": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        },
        "__schema8": {
          "type": "null"
        },
        "__schema9": {
          "type": "boolean",
          "const": true
        }
      }
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "workItem": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        }
      },
      "required": [
        "workItem"
      ]
    }
  },
  "POST /web/factory/projects": {
    "body": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "name": {
          "type": "string",
          "minLength": 1,
          "maxLength": 200
        },
        "description": {
          "anyOf": [
            {
              "type": "string",
              "maxLength": 2000
            },
            {
              "type": "null"
            }
          ]
        }
      },
      "required": [
        "name"
      ]
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "project": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        }
      },
      "required": [
        "project"
      ]
    }
  },
  "POST /web/factory/projects/:id/apply-default-model": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "modelId": {
          "type": "string"
        },
        "applied": {
          "type": "array",
          "items": {
            "type": "string"
          }
        },
        "skipped": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "threadId": {
                "type": "string"
              },
              "reason": {
                "type": "string",
                "enum": [
                  "not-running",
                  "work-item-missing",
                  "stage-inactive",
                  "thread-missing",
                  "mode-unknown",
                  "apply-failed"
                ]
              }
            },
            "required": [
              "threadId",
              "reason"
            ]
          }
        }
      },
      "required": [
        "modelId",
        "applied",
        "skipped"
      ]
    }
  },
  "POST /web/factory/projects/:id/attention/:kind/:sourceId/:occurrence/archive": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/$defs/__schema0"
        },
        "kind": {
          "$ref": "#/$defs/__schema1"
        },
        "sourceId": {
          "$ref": "#/$defs/__schema2"
        },
        "occurrence": {
          "$ref": "#/$defs/__schema3"
        }
      },
      "required": [
        "id",
        "kind",
        "sourceId",
        "occurrence"
      ],
      "$defs": {
        "__schema0": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        },
        "__schema1": {
          "type": "string",
          "enum": [
            "automation-failed",
            "automation-proposed",
            "mention",
            "activity",
            "supervisor-finding",
            "agent-waiting"
          ]
        },
        "__schema2": {
          "type": "string",
          "minLength": 1,
          "maxLength": 256
        },
        "__schema3": {
          "type": "string",
          "pattern": "^(0|[1-9]\\d*)$"
        }
      }
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "receipt": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        }
      },
      "required": [
        "receipt"
      ]
    }
  },
  "POST /web/factory/projects/:id/attention/:kind/:sourceId/:occurrence/read": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/$defs/__schema0"
        },
        "kind": {
          "$ref": "#/$defs/__schema1"
        },
        "sourceId": {
          "$ref": "#/$defs/__schema2"
        },
        "occurrence": {
          "$ref": "#/$defs/__schema3"
        }
      },
      "required": [
        "id",
        "kind",
        "sourceId",
        "occurrence"
      ],
      "$defs": {
        "__schema0": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        },
        "__schema1": {
          "type": "string",
          "enum": [
            "automation-failed",
            "automation-proposed",
            "mention",
            "activity",
            "supervisor-finding",
            "agent-waiting"
          ]
        },
        "__schema2": {
          "type": "string",
          "minLength": 1,
          "maxLength": 256
        },
        "__schema3": {
          "type": "string",
          "pattern": "^(0|[1-9]\\d*)$"
        }
      }
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "receipt": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        }
      },
      "required": [
        "receipt"
      ]
    }
  },
  "POST /web/factory/projects/:id/attention/:kind/:sourceId/:occurrence/restore": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/$defs/__schema0"
        },
        "kind": {
          "$ref": "#/$defs/__schema1"
        },
        "sourceId": {
          "$ref": "#/$defs/__schema2"
        },
        "occurrence": {
          "$ref": "#/$defs/__schema3"
        }
      },
      "required": [
        "id",
        "kind",
        "sourceId",
        "occurrence"
      ],
      "$defs": {
        "__schema0": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        },
        "__schema1": {
          "type": "string",
          "enum": [
            "automation-failed",
            "automation-proposed",
            "mention",
            "activity",
            "supervisor-finding",
            "agent-waiting"
          ]
        },
        "__schema2": {
          "type": "string",
          "minLength": 1,
          "maxLength": 256
        },
        "__schema3": {
          "type": "string",
          "pattern": "^(0|[1-9]\\d*)$"
        }
      }
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "receipt": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        }
      },
      "required": [
        "receipt"
      ]
    }
  },
  "POST /web/factory/projects/:id/attention/read-all": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "query": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "before": {
          "type": "string"
        }
      }
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "ok": {
          "type": "boolean",
          "const": true
        },
        "hasMore": {
          "type": "boolean"
        },
        "nextCursor": {
          "type": "string"
        }
      },
      "required": [
        "ok",
        "hasMore"
      ]
    }
  },
  "POST /web/factory/projects/:id/decisions/:decisionId/approve": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/$defs/__schema0"
        },
        "decisionId": {
          "$ref": "#/$defs/__schema0"
        }
      },
      "required": [
        "id",
        "decisionId"
      ],
      "$defs": {
        "__schema0": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      }
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "decision": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        }
      },
      "required": [
        "decision"
      ]
    }
  },
  "POST /web/factory/projects/:id/decisions/:decisionId/dismiss": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/$defs/__schema0"
        },
        "decisionId": {
          "$ref": "#/$defs/__schema0"
        }
      },
      "required": [
        "id",
        "decisionId"
      ],
      "$defs": {
        "__schema0": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      }
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "decision": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        }
      },
      "required": [
        "decision"
      ]
    }
  },
  "POST /web/factory/projects/:id/decisions/:decisionId/retry": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/$defs/__schema0"
        },
        "decisionId": {
          "$ref": "#/$defs/__schema0"
        }
      },
      "required": [
        "id",
        "decisionId"
      ],
      "$defs": {
        "__schema0": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      }
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "decision": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        }
      },
      "required": [
        "decision"
      ]
    }
  },
  "POST /web/factory/projects/:id/runs/start": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "body": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "sessionId": {
          "$ref": "#/$defs/__schema0"
        },
        "threadTitle": {
          "type": "string",
          "minLength": 1,
          "maxLength": 512
        },
        "kickoffKey": {
          "$ref": "#/$defs/__schema0"
        },
        "workItem": {
          "type": "object",
          "properties": {
            "id": {
              "$ref": "#/$defs/__schema0"
            },
            "role": {
              "type": "string",
              "minLength": 1,
              "maxLength": 32
            },
            "input": {
              "type": "object",
              "properties": {
                "title": {
                  "type": "string",
                  "maxLength": 500
                },
                "board": {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 128
                },
                "externalSource": {
                  "anyOf": [
                    {
                      "type": "object",
                      "properties": {
                        "integrationId": {
                          "type": "string",
                          "minLength": 1,
                          "maxLength": 128
                        },
                        "type": {
                          "type": "string",
                          "minLength": 1,
                          "maxLength": 128
                        },
                        "externalId": {
                          "type": "string",
                          "minLength": 1,
                          "maxLength": 512
                        },
                        "url": {
                          "type": "string",
                          "maxLength": 2048
                        }
                      },
                      "required": [
                        "integrationId",
                        "type",
                        "externalId"
                      ]
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "parentWorkItemId": {
                  "anyOf": [
                    {
                      "type": "string",
                      "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
                    },
                    {
                      "type": "null"
                    }
                  ]
                },
                "stages": {
                  "minItems": 1,
                  "maxItems": 16,
                  "type": "array",
                  "items": {
                    "$ref": "#/$defs/__schema1"
                  }
                },
                "sessions": {
                  "type": "object",
                  "propertyNames": {
                    "type": "string",
                    "minLength": 1,
                    "maxLength": 64
                  },
                  "additionalProperties": {
                    "type": "object",
                    "properties": {
                      "sessionId": {
                        "type": "string",
                        "minLength": 1,
                        "maxLength": 512
                      },
                      "branch": {
                        "type": "string",
                        "minLength": 1,
                        "maxLength": 512
                      },
                      "threadId": {
                        "type": "string",
                        "minLength": 1,
                        "maxLength": 512
                      }
                    },
                    "required": [
                      "sessionId",
                      "branch",
                      "threadId"
                    ]
                  }
                },
                "metadata": {
                  "anyOf": [
                    {
                      "$ref": "#/$defs/__schema2"
                    },
                    {
                      "$ref": "#/$defs/__schema3"
                    }
                  ]
                }
              },
              "required": [
                "title"
              ]
            }
          },
          "required": [
            "id",
            "role",
            "input"
          ]
        }
      },
      "required": [
        "sessionId",
        "threadTitle",
        "kickoffKey",
        "workItem"
      ],
      "$defs": {
        "__schema0": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        },
        "__schema1": {
          "type": "string",
          "maxLength": 64,
          "pattern": "^[a-z0-9][a-z0-9_-]*$"
        },
        "__schema2": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        },
        "__schema3": {
          "type": "null"
        }
      }
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "propertyNames": {
        "type": "string"
      },
      "additionalProperties": {}
    }
  },
  "POST /web/factory/projects/:id/supervisor/session": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "sessionId": {
          "type": "string"
        },
        "threadId": {
          "type": "string"
        },
        "factoryProjectId": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "sessionId",
        "threadId",
        "factoryProjectId"
      ]
    }
  },
  "POST /web/factory/projects/:id/work-items": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      },
      "required": [
        "id"
      ]
    },
    "body": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "title": {
          "type": "string",
          "maxLength": 500
        },
        "board": {
          "type": "string",
          "minLength": 1,
          "maxLength": 128
        },
        "externalSource": {
          "anyOf": [
            {
              "type": "object",
              "properties": {
                "integrationId": {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 128
                },
                "type": {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 128
                },
                "externalId": {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 512
                },
                "url": {
                  "type": "string",
                  "maxLength": 2048
                }
              },
              "required": [
                "integrationId",
                "type",
                "externalId"
              ]
            },
            {
              "type": "null"
            }
          ]
        },
        "parentWorkItemId": {
          "anyOf": [
            {
              "type": "string",
              "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
            },
            {
              "type": "null"
            }
          ]
        },
        "stages": {
          "minItems": 1,
          "maxItems": 16,
          "type": "array",
          "items": {
            "$ref": "#/$defs/__schema0"
          }
        },
        "sessions": {
          "type": "object",
          "propertyNames": {
            "type": "string",
            "minLength": 1,
            "maxLength": 64
          },
          "additionalProperties": {
            "type": "object",
            "properties": {
              "sessionId": {
                "type": "string",
                "minLength": 1,
                "maxLength": 512
              },
              "branch": {
                "type": "string",
                "minLength": 1,
                "maxLength": 512
              },
              "threadId": {
                "type": "string",
                "minLength": 1,
                "maxLength": 512
              }
            },
            "required": [
              "sessionId",
              "branch",
              "threadId"
            ]
          }
        },
        "metadata": {
          "anyOf": [
            {
              "$ref": "#/$defs/__schema1"
            },
            {
              "$ref": "#/$defs/__schema2"
            }
          ]
        }
      },
      "required": [
        "title"
      ],
      "$defs": {
        "__schema0": {
          "type": "string",
          "maxLength": 64,
          "pattern": "^[a-z0-9][a-z0-9_-]*$"
        },
        "__schema1": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        },
        "__schema2": {
          "type": "null"
        }
      }
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "workItem": {
          "type": "object",
          "propertyNames": {
            "type": "string"
          },
          "additionalProperties": {}
        }
      },
      "required": [
        "workItem"
      ]
    }
  },
  "POST /web/factory/projects/:id/work-items/:workItemId/automation-runs": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/$defs/__schema0"
        },
        "workItemId": {
          "$ref": "#/$defs/__schema0"
        }
      },
      "required": [
        "id",
        "workItemId"
      ],
      "$defs": {
        "__schema0": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      }
    },
    "body": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "requestId": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        },
        "expectedRevision": {
          "type": "integer",
          "minimum": 1,
          "maximum": 9007199254740991
        },
        "role": {
          "type": "string",
          "enum": [
            "triage",
            "plan",
            "work",
            "review"
          ]
        },
        "skillName": {
          "type": "string",
          "minLength": 1,
          "maxLength": 128
        },
        "arguments": {
          "type": "string",
          "minLength": 1,
          "maxLength": 4096
        }
      },
      "required": [
        "requestId",
        "expectedRevision",
        "role",
        "skillName"
      ],
      "additionalProperties": false
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "propertyNames": {
        "type": "string"
      },
      "additionalProperties": {}
    }
  },
  "POST /web/factory/projects/:id/work-items/:workItemId/transition": {
    "path": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "id": {
          "$ref": "#/$defs/__schema0"
        },
        "workItemId": {
          "$ref": "#/$defs/__schema0"
        }
      },
      "required": [
        "id",
        "workItemId"
      ],
      "$defs": {
        "__schema0": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        }
      }
    },
    "body": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "properties": {
        "board": {
          "type": "string",
          "maxLength": 128,
          "pattern": "^[a-z0-9][a-z0-9_-]*$"
        },
        "stage": {
          "type": "string",
          "maxLength": 128,
          "pattern": "^[a-z0-9][a-z0-9_-]*$"
        },
        "expectedRevision": {
          "type": "integer",
          "minimum": 1,
          "maximum": 9007199254740991
        },
        "requestId": {
          "type": "string",
          "pattern": "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$"
        },
        "cause": {
          "type": "string",
          "minLength": 1,
          "maxLength": 256
        },
        "reenter": {}
      },
      "required": [
        "board",
        "stage",
        "expectedRevision",
        "requestId",
        "cause"
      ]
    },
    "response": {
      "$schema": "https://json-schema.org/draft/2020-12/schema",
      "type": "object",
      "propertyNames": {
        "type": "string"
      },
      "additionalProperties": {}
    }
  }
} as const;

export const FACTORY_API_ROUTE_CATALOG = {
  "projectDelete": "DELETE /web/factory/projects/:id",
  "workItemDelete": "DELETE /web/factory/work-items/:id",
  "projectList": "GET /web/factory/projects",
  "projectGet": "GET /web/factory/projects/:id",
  "attentionList": "GET /web/factory/projects/:id/attention",
  "boardCatalog": "GET /web/factory/projects/:id/boards",
  "decisionList": "GET /web/factory/projects/:id/decisions",
  "healthThresholdsGet": "GET /web/factory/projects/:id/health/thresholds",
  "metricsGet": "GET /web/factory/projects/:id/metrics",
  "supervisorHealth": "GET /web/factory/projects/:id/supervisor/health",
  "workItemList": "GET /web/factory/projects/:id/work-items",
  "projectUpdate": "PATCH /web/factory/projects/:id",
  "workItemUpdate": "PATCH /web/factory/work-items/:id",
  "projectCreate": "POST /web/factory/projects",
  "projectApplyDefaultModel": "POST /web/factory/projects/:id/apply-default-model",
  "attentionArchive": "POST /web/factory/projects/:id/attention/:kind/:sourceId/:occurrence/archive",
  "attentionRead": "POST /web/factory/projects/:id/attention/:kind/:sourceId/:occurrence/read",
  "attentionRestore": "POST /web/factory/projects/:id/attention/:kind/:sourceId/:occurrence/restore",
  "attentionReadAll": "POST /web/factory/projects/:id/attention/read-all",
  "decisionApprove": "POST /web/factory/projects/:id/decisions/:decisionId/approve",
  "decisionDismiss": "POST /web/factory/projects/:id/decisions/:decisionId/dismiss",
  "decisionRetry": "POST /web/factory/projects/:id/decisions/:decisionId/retry",
  "workItemStart": "POST /web/factory/projects/:id/runs/start",
  "supervisorSession": "POST /web/factory/projects/:id/supervisor/session",
  "workItemCreate": "POST /web/factory/projects/:id/work-items",
  "workItemAutomationRun": "POST /web/factory/projects/:id/work-items/:workItemId/automation-runs",
  "workItemTransition": "POST /web/factory/projects/:id/work-items/:workItemId/transition"
} as const;
